import TalkSessionForm from './form/talksession';

const talksession = new TalkSessionForm();